import { Component, OnInit, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { AppUrls } from '../../../utility/appurls';
import { GenericLookupForm } from '../generic-lookup-form';
import { MaskUtility } from '../../../utility/mask-utility';
import { DynamicFormsService } from '../../../dynamic-forms/services/dynamic-forms/dynamic-forms.service';
import { FormsModule } from '@angular/forms';
import { DynamicFormLoadDirective } from '../../../dynamic-forms/directives/dynamic-form-structural.directive';
import { TextInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/text-input/text-input.component';
import { GenericInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/generic-input/generic-input.component';

@Component({
  selector: 'app-healthcare-provider-lookup-supervisory-relationship-form',
  templateUrl: './healthcare-provider-lookup-supervisory-relationship-form.component.html',
  styleUrls: ['./healthcare-provider-lookup-supervisory-relationship-form.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [FormsModule, DynamicFormLoadDirective , TextInputComponent, GenericInputComponent],
})
export class HealthcareProviderLookupSupervisoryRelationshipFormComponent
  extends GenericLookupForm
  implements OnInit {
  private dynamicFormsService = inject(DynamicFormsService);

  @Input() queryObject: any;
  @Output() enterKey: EventEmitter<any> = new EventEmitter();
  formLoaded = false;
  AppUrls = AppUrls;

  hpIdMaskConfig = MaskUtility.getEntityIdMask('HP');

  
 

  constructor() {
    super();
  }

  ngOnInit() {
    this.dynamicFormsService
      .getFormGroupForModel('healthcareProviderLookupSupervisoryRelationship')
      .subscribe(formInfo => {
        this.formInfo = formInfo;
        this.form = formInfo.formGroup;
        this.form.controls['healthcareProviderProfession'].setValue(
          this.queryObject.healthcareProviderProfession,
        );
        this.formLoaded = true;
      });
  }

  search() {
    this.enterKey.emit();
  }

  public isValid(): boolean {
    // Valid means that some value has been entered

    return this.form && this.form.valid;
  }
}
